<script type="text/javascript">
// 定义一些公共的属性和方法
import request from '@/utils/request'

function enums(type) {
  return request({
    url: '/sys/dictionary/enums/' + type,
    method: 'get'
  })
}
// 暴露出这些属性和方法
export default {
  enums
}
</script>
